<template>
  <div class="camp-center-entry" @click="$emit('open')">
    <img class="center-avatar" src="@/assets/images/researchCamp/banner.png" alt="">
    <div class="center-main">
      <div class="center-name">{{ camp.campName }}</div>
      <div class="center-date" v-if="camp.provinceName || camp.cityName">
        <span v-if="camp.provinceName">{{ camp.provinceName }}</span>
        <span v-if="camp.cityName">{{ camp.cityName }}</span>
      </div>
    </div>
    <span class="center-entry">{{ actionText }}</span>
  </div>
</template>

<script>
export default {
  name: 'CampCenterEntry',
  props: {
    camp: {
      type: Object,
      default () {
        return {}
      }
    },
    actionText: {
      type: String,
      default: '进入中心'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.camp-center-entry {
  .camp-white-card();
  display: flex;
  align-items: center;
  height: 78px;
  margin-top: 13px;
  padding: 0 14px;

  .center-avatar {
    width: 45px;
    height: 45px;
    margin-right: 12px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .center-main {
    flex: 1;
    min-width: 0;
  }

  .center-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 20px;
    color: @camp-text;
  }

  .center-date {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    line-height: 20px;
    color: @camp-sub;

    span + span {
      margin-left: 4px;
    }
  }

  .center-entry {
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    color: #fff;
    background: @camp-red;
    font-size: 12px;
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampCenterEntry.vue